<template>
  <div class="sop-filter">
    <div style="display: flex;">
      <div v-if="['SE'].includes(lob)" class="more-filter-btn" @click="expandCondition = !expandCondition">
        {{ $t('CargoMsg.Cargo_MoreFilters') }}
        <i :class="expandCondition ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
      </div>
      <slot v-else name="filter" />
      <slot name="other" />
    </div>
    <search-item
      v-if="lob === 'SE'"
      v-show="expandCondition"
      key="SESearchItem"
      ref="SESearchItem"
      config-module="100100"
      :show-simple="false"
      :expand-adv="true"
      :reset="true"
      :custom-search-items="customSearchItems"
      @advSearchItemCallBack="toAdvancedQuery"
      @resetFields="toResetFields"
      @defaultSearchItemsChange="value=>{defaultSearchItems=value}"
    >
      <!-- 委托单位【SOP筛选委托单位仅销售个人的客户】 -->
      <cargo-advance-select
        slot="customType1"
        slot-scope="{ item, getValueFromChild }"
        :select-type="TYPE_NAMES.basic_data_Company"
        filterable
        :callback-params="{ refCode: item.itemName, fieldType: item.fieldType }"
        :default-value="item.itemValue"
        :static-options="seCompanyOptions"
        @parentCallBack="data=>getValueFromChild(data)"
      />
      <!-- 收货人企业名【增加销售控制】 -->
      <cargo-advance-select
        slot="customType2"
        slot-scope="{ item, getValueFromChild }"
        :select-type="TYPE_NAMES.basic_data_Company"
        :method-params="{ consignee: true, active: true }"
        filterable
        :callback-params="{ refCode: item.itemName, fieldType: item.fieldType }"
        :default-value="item.itemValue"
        :static-options="sePrivateConsigneeList"
        @parentCallBack="data=>getValueFromChild(data)"
      />
    </search-item>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import { PRIORITIES } from '@/class/cargo/model/parameters/SystemConstants'
import * as BillReleaseType from '@/class/cargo/model/parameters/BillReleaseType'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getCacheListByKey, getFilterCacheList } from '@/utils/basicDataCache'
import dateUtils from '@/utils/dateUtils'
import { sleep, ensureExecuteSuccess } from '@/utils/commonUtil'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { queryCompanyCmpIdxByCompanyUser, queryCompanyUserByCompany } from '@/api/company'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'SopFilter',
  components: { searchItem, CargoAdvanceSelect },
  props: {
    lob: { type: String, default: '' },
    sopTemplates: { type: Array, default: () => [] },
    isSalesForSzfs: { type: Boolean, default: false },
    defaultLevels: { type: Array, default: () => [] }
  },
  data() {
    return {
      TYPE_NAMES,
      searchItemInitFlag: false,
      expandCondition: false,
      customSearchItems: [],
      businessTimeDefault: dateUtils.formatStandardDateTime(new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate() - 90)),
      hblBillReleases: [],
      searchParams: {
        conditions: []
      },
      defaultSearchItems: [],
      formAllKeys: [
        'jobNo',
        'masterJobNo',
        'mblNo',
        'ieMblNo',
        'rMblNo',
        'soNo',
        'loadingPortCode',
        'destinationAgent',
        'containerLoadType',
        'region',
        'transportLine',
        'vessel',
        'carrierId',
        'voyageFlight',
        'createStartTime',
        'createEndTime',
        'businessStartTime',
        'businessEndTime',
        'actualUnBerthPlanDateStart',
        'actualUnBerthPlanDateEnd',
        'hblSignDateBLStart',
        'hblSignDateBLEnd',
        'customsDateStart',
        'customsDateEnd',
        'level',
        'customerId',
        'destinationAgent2',
        'exChangeAgent',
        'opDepartment',
        'opId',
        'dc',
        'csr',
        'overseaOp',
        'trackingTemplateUuid',
        'khPlateNumber',
        'khTrailerNumber',
        'dispatchingPlace',
        'actualUnBerthPlanDate',
        'hblSignDateBL',
        'hblReleaseType',
        'consigneeId',
        'userDefinedRoleId1',
        'userDefinedRoleId2',
        'userDefinedRoleId3',
        'userDefinedRoleId4',
        'userDefinedRoleId5',
        'userDefinedRoleId6',
        'userDefinedRoleId7',
        'userDefinedRoleId1',
        'userDefinedRoleId1',
        'planner',
        'planners',
        'customsDate'
      ],
      privilege: {
        hasSopOfCustomerForSelfSales: this.$checkPermission(['role_sales_SopOfCustomerForSelfSales']),
        hasChooseOwnTransceiverPermission: this.$checkPermission(['role_RemoteBooking_ChooseOwnTransceiver']) && !this.$store.getters.isAdmin // 有选择自己的收发通的权限
      },
      seCompanyOptions: null,
      sePrivateConsigneeList: null
    }
  },
  computed: {
    searchItemRefName() {
      return this.lob + 'SearchItem'
    },
    formSearchItemMap() {
      const result = new Map()
      result.set('trackingTemplateUuid', 'job.TRACKING_TEMPLATE_UUID')
      result.set('level', 'priorityInfo.LEVEL')
      result.set('businessTime', 'job.ETD')
      return result
    },
    priorityOptions() {
      if (this.defaultLevels && this.defaultLevels.length > 0) {
        return PRIORITIES.filter(item => this.defaultLevels.includes(item.code))
      }
      return PRIORITIES
    }
  },
  watch: {
    lob: {
      immediate: true,
      async handler() {
        this.expandCondition = false
        this.searchParams.conditions = []
        if (this.lob === 'SE') {
          this.searchParams.conditions.push(new AdvancedSearchOption(null, 'job.ETD', `type=date,start=${this.businessTimeDefault} 00:00:00`, AdvancedSearchConsts.OPERATOR_RANGE.code).formatObj2Json())
        }
        if (this.defaultLevels && this.defaultLevels.length > 0) {
          this.searchParams.conditions.push(new AdvancedSearchOption(null, 'priorityInfo.LEVEL', this.defaultLevels, AdvancedSearchConsts.OPERATOR_IN.code).formatObj2Json())
        }
        this.customSearchItems = await this.getCustomSearchItems()
        this.searchItemInitFlag = true
        setTimeout(() => {
          this.searchItemInitFlag = false
          this.setSearchItemValue('job.ETD', [this.businessTimeDefault])
          this.setSearchItemValue('priorityInfo.LEVEL', this.defaultLevels)
          if (this.$store.state.uiCustom.enable) {
            UICustomUtil.handleSearchItems(UICustomConstants.SEA_BOOKING_MODULE, this.defaultSearchItems, this.customSearchItems)
          }
        }, 5000)
      }
    },
    async sopTemplates() {
      this.customSearchItems = await this.getCustomSearchItems()
    },
    '$store.getters.currentOfficeId': {
      async handler() {
        this.customSearchItems = await this.getCustomSearchItems()
      }
    }
  },
  created() {
    // 提单方式
    const billReleases = BillReleaseType.BILL_RELEASES.map(item => {
      return { code: item.serialNumber, chineseName: item.name, englishName: item.name }
    })
    const hblBillReleases = [...billReleases]
    const blModeList = getCacheListByKey(basicCacheKeys.basic_data_BlMode)
    if (blModeList && blModeList.length > 0) {
      for (const blMode of blModeList) {
        if (blMode.blType === 3) {
          hblBillReleases.push({
            code: blMode.serialNumber,
            chineseName: blMode.localName,
            englishName: blMode.localName
          })
        }
      }
    }
    this.hblBillReleases = hblBillReleases
  },
  methods: {
    async getCustomSearchItems() {
      await cache.load(cacheName.CONFIG)
      const isSpecifiedSalesBusiness = Number(cache.config.get('IsSpecifiedSalesBusiness')) === 1
      const defaultSearchFields = []
      if (this.lob === 'SE') {
        defaultSearchFields.push({
          'action': 2,
          'itemType': 'advanceSelect2',
          'fieldType': 'FIELD_DROP_DOWN_LIST',
          'multiple': 0,
          'itemCondition': [{
            'code': '=',
            'chineseName': '等于',
            'englishName': 'Equal',
            'children': null,
            'selected': false
          }],
          'defaultConditionVal': '=',
          'itemName': 'job.TRACKING_TEMPLATE_UUID',
          'itemLabel': 'CargoMsg.Cargo_SopTemplate',
          'itemValue': '',
          'defaultSelected': 1,
          'selected': 1,
          'dropdownDataRef': '',
          'dataCacheKey': '',
          'valueExpression': {
            valueType: 'static',
            valueContent: this.sopTemplates
          },
          'filterTagNames': ['templateName'],
          'tagValue': 'uuid',
          'tagName': 'templateName',
          'lock': false,
          'fix': true,
          'defaultValue': ''
        }, {
          'action': 2,
          'itemType': 'date',
          'fieldType': 'FIELD_DATE_RANGE',
          'itemCondition': [{
            'code': 'RANGE',
            'chineseName': '范围',
            'englishName': 'Range',
            'children': null,
            'selected': false
          }],
          'subType': 'range',
          'defaultConditionVal': 'RANGE',
          'itemName': 'job.ETD',
          'itemLabel': 'CargoMsg.Cargo_BusinessTime',
          'itemValue': [],
          'defaultSelected': 1,
          'selected': 1,
          'valueExpression': '',
          'lock': false,
          'fix': true,
          'defaultValue': [this.businessTimeDefault]
        }, {
          'action': 2,
          'itemType': 'advanceSelect2',
          'fieldType': 'FIELD_DROP_DOWN_LIST',
          'multiple': 1,
          'itemCondition': [{
            'code': 'IN',
            'chineseName': '包含',
            'englishName': 'In',
            'children': null,
            'selected': false
          }],
          'defaultConditionVal': 'IN',
          'itemName': 'priorityInfo.LEVEL',
          'itemLabel': 'CargoMsg.Cargo_Priority',
          'itemValue': [],
          'defaultSelected': 1,
          'selected': 1,
          'dropdownDataRef': '',
          'dataCacheKey': '',
          'valueExpression': {
            valueType: 'static',
            valueContent: this.priorityOptions
          },
          'tagValue': 'code',
          'tagName': 'chineseName',
          'lock': false,
          'fix': true,
          'defaultValue': this.defaultLevels
        }, {
          'action': 2,
          'itemType': 'select',
          'fieldType': 'FIELD_DROP_DOWN_LIST',
          'multiple': 0,
          'itemCondition': [{
            'code': '=',
            'chineseName': '等于',
            'englishName': 'Equal',
            'children': null,
            'selected': false
          }],
          'defaultConditionVal': '=',
          'itemName': 'cargoDocHBL.RELEASE_TYPE',
          'itemLabel': 'SeaExport.HBLBlType',
          'itemValue': '',
          'defaultSelected': 1,
          'selected': 0,
          'dropdownDataRef': '',
          'dataCacheKey': '',
          'valueExpression': {
            valueType: 'static',
            valueContent: this.hblBillReleases
          },
          'tagValue': 'code',
          'tagName': 'chineseName',
          'lock': false,
          'defaultValue': ''
        })
        // 配置【SOP筛选委托单位仅销售个人的客户】权限时，仅查看属于自己的客户
        if (!this.$store.getters.isAdmin && this.privilege.hasSopOfCustomerForSelfSales) {
          if (!this.seCompanyOptions) {
            await queryCompanyUserByCompany({ userId: this.$store.getters.userId, roleType: 2, lob: 'SE' }).then(res => {
              this.seCompanyOptions = getFilterCacheList(TYPE_NAMES.basic_data_Company, p => res.data.includes(p.uuid) && p.active)
            })
          }
          // 移除原【委托单位】条件
          let searchField = new AdvancedSearchField()
          searchField.action = AdvancedSearchField.REMOVE_ACTION
          searchField.itemType = 'company'
          searchField.fieldType = 'FIELD_CUSTOMER'
          searchField.itemName = 'job.CUSTOMER_ID'
          defaultSearchFields.push(searchField.formatObj2Json())
          // 新的【委托单位】条件
          searchField = new AdvancedSearchField()
          searchField.action = AdvancedSearchField.UPDATE_ACTION
          searchField.itemType = 'customType1'
          searchField.fieldType = 'FIELD_CUSTOMER'
          searchField.itemName = 'job.CUSTOMER_ID'
          searchField.itemLabel = 'SeaExport.ConsignationCompany'
          searchField.defaultSelected = 1
          defaultSearchFields.push(searchField.formatObj2Json())
        }
        if (this.isSalesForSzfs) {
          // 移除【目的港代理】条件
          let searchField = new AdvancedSearchField()
          searchField.action = AdvancedSearchField.REMOVE_ACTION
          searchField.itemType = 'company'
          searchField.fieldType = 'FIELD_SEA_DEST_AGENT'
          searchField.itemName = 'job.DESTINATION_AGENT'
          defaultSearchFields.push(searchField.formatObj2Json())
          // 移除【换单代理】条件
          searchField = new AdvancedSearchField()
          searchField.action = AdvancedSearchField.REMOVE_ACTION
          searchField.itemType = 'company'
          searchField.fieldType = 'FIELD_BOOKING_AGENT'
          searchField.itemName = 'job.EX_CHANGE_AGENT'
          defaultSearchFields.push(searchField.formatObj2Json())
        }
        // 筛选条件【收货人企业名】增加销售控制
        // 当前登录用户服务人员是自己的收货人列表
        if (isSpecifiedSalesBusiness && this.privilege.hasChooseOwnTransceiverPermission) {
          if (!this.sePrivateConsigneeList) {
            await queryCompanyCmpIdxByCompanyUser({ userId: this.$store.getters.userId, lob: 'SE' }).then(res => {
              this.sePrivateConsigneeList = getFilterCacheList(TYPE_NAMES.basic_data_Company, p => (res.data.includes(p.uuid) || p.createdBy === this.$store.getters.userId) &&
                p.active && p.seaExport && p.consignee && (p.branchId === this.$store.getters.currentOfficeId || p.branchId === 1))
            })
          }
          // 移除原【收货人企业名】条件
          let searchField = new AdvancedSearchField()
          searchField.action = AdvancedSearchField.REMOVE_ACTION
          searchField.itemType = 'company'
          searchField.fieldType = 'FIELD_COMPANY'
          searchField.itemName = 'job.CONSIGNEE_ID'
          defaultSearchFields.push(searchField.formatObj2Json())
          // 新的【收货人企业名】条件
          searchField = new AdvancedSearchField()
          searchField.action = AdvancedSearchField.UPDATE_ACTION
          searchField.itemType = 'customType2'
          searchField.fieldType = 'FIELD_COMPANY'
          searchField.itemName = 'job.CONSIGNEE_ID'
          searchField.itemLabel = 'Message.ConsigneeCompanyName'
          searchField.defaultSelected = 1
          defaultSearchFields.push(searchField.formatObj2Json())
        }
      }
      return defaultSearchFields
    },
    toAdvancedQuery(data) {
      const newSearchParams = { conditions: data }
      for (const [formItemName, fieldName] of this.formSearchItemMap.entries()) {
        const option = AdvancedSearchOption.getOption(fieldName, data)
        if (option) {
          if (formItemName === 'level') {
            newSearchParams[formItemName] = this.toTxt(option.value)
          } else if (formItemName === 'businessTime') {
            option.value.split(',').forEach(function(item) {
              if (item.indexOf('start=') > -1) {
                newSearchParams['businessStartTime'] = item.replace('start=', '')
              }
              if (item.indexOf('end=') > -1) {
                newSearchParams['businessEndTime'] = item.replace('end=', '')
              }
            })
          } else {
            newSearchParams[formItemName] = option.value
          }
        }
      }
      this.searchParams = newSearchParams
      this.handleFilter()
    },
    initTemplateKey(templateKey) {
      this.searchParams.trackingTemplateUuid = templateKey || ''
      let templateOption = AdvancedSearchOption.removeOption('job.TRACKING_TEMPLATE_UUID', this.searchParams.conditions)
      if (templateKey) {
        if (templateOption) {
          templateOption.value = templateKey
        } else {
          templateOption = new AdvancedSearchOption(null, 'job.TRACKING_TEMPLATE_UUID', templateKey, AdvancedSearchConsts.OPERATOR_EQUAL.code).formatObj2Json()
        }
        this.searchParams.conditions.push(templateOption)
      }
      this.setSearchItemValue('job.TRACKING_TEMPLATE_UUID', templateKey || '')
    },
    initLevel(level) {
      level = level || ''
      this.searchParams.level = level
      let levelOption = AdvancedSearchOption.removeOption('priorityInfo.LEVEL', this.searchParams.conditions)
      if (level) {
        if (levelOption) {
          levelOption.value = this.toNumArray(level)
        } else {
          levelOption = new AdvancedSearchOption(null, 'priorityInfo.LEVEL', this.toNumArray(level), AdvancedSearchConsts.OPERATOR_IN.code).formatObj2Json()
        }
        this.searchParams.conditions.push(levelOption)
      }
      this.setSearchItemValue('priorityInfo.LEVEL', this.toNumArray(level))
    },
    handleFilter() {
      const searchRemoveKeys = []
      for (const formItemKey of this.formAllKeys) {
        if (!this.searchParams.hasOwnProperty(formItemKey)) {
          searchRemoveKeys.push(formItemKey)
        }
      }
      this.$emit('search', this.searchParams, searchRemoveKeys)
    },
    clear() {
      this.searchParams = { conditions: [] }
      if (this.lob === 'SE') {
        this.searchParams.conditions = [new AdvancedSearchOption(null, 'job.ETD', `type=date,start=${this.businessTimeDefault} 00:00:00`, AdvancedSearchConsts.OPERATOR_RANGE.code).formatObj2Json()]
      }
      if (this.defaultLevels && this.defaultLevels.length > 0) {
        this.searchParams.conditions.push(new AdvancedSearchOption(null, 'priorityInfo.LEVEL', this.defaultLevels, AdvancedSearchConsts.OPERATOR_IN.code).formatObj2Json())
      }
      // ensureExecuteSuccess(() => !!this.$refs[this.searchItemRefName]).then(() => {
      //   this.$refs[this.searchItemRefName].toResetFields()
      // })
    },
    async setSearchItemValue(itemName, itemValue) {
      if (this.searchItemInitFlag) {
        await sleep(1000)
      }
      await ensureExecuteSuccess(() => !!this.$refs[this.searchItemRefName])
      const multipleSelection = this.$refs[this.searchItemRefName].multipleSelection
      const searchItem = multipleSelection.find(item => item.itemName === itemName)
      if (searchItem) {
        searchItem.itemValue = itemValue
      }
    },
    toResetFields(multipleSelection) {
      console.log('toResetFields', multipleSelection)
      const searchItem1 = multipleSelection.find(item => item.itemName === 'job.TRACKING_TEMPLATE_UUID')
      if (searchItem1) {
        searchItem1.itemValue = ''
      }
      const searchItem2 = multipleSelection.find(item => item.itemName === 'job.ETD')
      if (searchItem2) {
        searchItem2.itemValue = [this.businessTimeDefault]
      }
      const searchItem3 = multipleSelection.find(item => item.itemName === 'priorityInfo.LEVEL')
      if (searchItem3) {
        searchItem3.itemValue = this.defaultLevels
      }
    },
    toNumArray(txt) {
      if (txt) {
        return Array.from(txt.split(','), p => Number(p))
      }
      return []
    },
    toTxt(strs) {
      if (strs && strs.length > 0) {
        return strs.join(',')
      }
      return ''
    }
  }
}
</script>

<style scoped lang="scss">
#app .sop-filter {
  display: flex;
  flex-direction: column;
  .more-filter-btn {
    width: fit-content;
    height: 28px;
    line-height: 28px;
    padding-left: 10px;
    padding-right: 5px;
    margin-right: 5px;
    color: #ffffff;
    background-color: #1F75D5;
    cursor: pointer;
    border: 1px solid #1F75D5;
    border-radius: 4px;
    i {
      font-size: 18px;
      vertical-align: middle;
    }
  }
}
</style>
